import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    padding: 0 6px;
    border-radius: 100px;
    gap: 6px;
    user-select: none;
    flex-shrink: 0;

    background: white;
    color: ${theme.colors.primary.fuchsia[50]};

    cursor: pointer;

    &:hover {
      background: ${theme.colors.neutral.variant[10]};
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
